import React, { useEffect, useState } from 'react'
import { Link, useParams } from "react-router-dom";
import { fetchAllProjectList, fetchProjectList } from '../../redux/projectReducer';
import { useDispatch, useSelector } from 'react-redux';
import './ViewUserDetail.css'
import { Form, InputGroup } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { Prev } from 'react-bootstrap/esm/PageItem';
import axios from 'axios';
// import { fetchAllCompletedProjectList } from '../../redux/completedReducer';


function ViewUserDetail() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const userUID = id;
  console.log(userUID);
  const { data, allData } = useSelector((state) => state.projects);
  //  const { allCompletedData , loader, error } = useSelector((state) => state.completedProjects);
  // console.log(allCompletedData);

  const [currentPage, setCurrentPage] = useState(1);
  const [lim, setLim] = useState(10);
  const [loading, setLoading] = useState(true);
  const [selectedState, setSelectedState] = useState('Ongoing')
  const [sortedData, setSortedData] = useState([]);
  const [search, setSearch] = useState(''); 
  const [statusMessage, setStatusMessage] = useState('');
  const [accountStatus, setAccountStatus] = useState('');
  console.log("accountStatus",accountStatus);
  


  
  useEffect(() => {
    setLoading(true)
    dispatch(fetchProjectList({ userUID, page: currentPage, lim }));
    setLoading(false)
  }, [currentPage, lim, dispatch, userUID]);

  useEffect(() => {
    setLoading(true)
    dispatch(fetchAllProjectList({ userUID }));
    setLoading(false)
  }, [userUID, dispatch ]);

  // useEffect(()=>{
  //   window.location.reload();
  // },[])
  useEffect(() => {
    const delay = setTimeout(() => {
      setLoading(true); // Start loading after delay

      const timer = setTimeout(() => {
        setLoading(false); // Stop loading after 2 seconds
      }, 2000);

      return () => clearTimeout(timer); // Cleanup inner timeout
    }, 2000); // Delays the entire effect by 3 seconds

    return () => clearTimeout(delay); // Cleanup the delay timeout if unmounted
  }, []);

    // Call the fetchAccountStatus when the component mounts
    useEffect(() => {
      fetchAccountStatus();
    }, []);




  //length of data and for the map function of the allData 

  const OngoingLength = allData.clients.filter((client) => client.status === 'Ongoing').length;
  const CompletedLength = allData.clients.filter((client) => client.status === 'completed').length;
  const filterData = allData?.clients?.filter((client) => client.status === selectedState) || [];

  const filteredResults = search.toLowerCase() === ""
    ? filterData
    : filterData.filter((item) => {
      const searchQuery = search.toLowerCase();
      return (
        (item.pname?.toLowerCase().includes(searchQuery) || "") ||
        (item.cname?.toLowerCase().includes(searchQuery) || "") ||
        (item.cphone ? String(item.cphone).toLowerCase().includes(searchQuery) : false)
      );

    });

///////////////////////////////////////////////////////////////////
    // function for make as completed 

    const statesMode = async (e) => {
    
      Swal.fire({
        title: "Do you want to complete the Project?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Complete",
        denyButtonText: `Don't complete`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          let newStatus = "completed";
          try {
            const response = await fetch(
              "https://us-central1-fabdiz-quote.cloudfunctions.net/api/updateClientStatus",
              {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ cid: e, newStatus }),
              }
            );
    
            const data = await response.json();
    
            if (response.ok) {
              console.log(data.message);
              dispatch(fetchProjectList({ userUID, page: currentPage, lim })); // Refresh project list
              Swal.fire("Project marked as completed!", "", "success").then(() => {
                window.location.reload(); // Reloads the page after clicking OK
              });
              
            } else {
              Swal.fire("Error", data.message || "Failed to update status", "error");
            }
          } catch (error) {
            console.error("Error updating project status:", error);
            Swal.fire("Error", "Something went wrong", "error");
          }
        } else if (result.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
        }
      });
    };

     // function for make as Ongoing 

     const ongoingStatesMode = async (e)=>{
         
      Swal.fire({
        title: "Do you want to Ongoing the Project?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Ongoing",
        denyButtonText: `Don't Ongoing`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          let newStatus = "Ongoing";
          try {
            const response = await fetch(
              "https://us-central1-fabdiz-quote.cloudfunctions.net/api/updateClientStatus",
              {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ cid: e, newStatus }),
              }
            );
    
            const data = await response.json();
    
            if (response.ok) {
              console.log(data.message);
              dispatch(fetchProjectList({ userUID, page: currentPage, lim })); // Refresh project list
              Swal.fire("Project marked as completed!", "", "success").then(() => {
                window.location.reload(); // Reloads the page after clicking OK
              });
              
            } else {
              Swal.fire("Error", data.message || "Failed to update status", "error");
            }
          } catch (error) {
            console.error("Error updating project status:", error);
            Swal.fire("Error", "Something went wrong", "error");
          }
        } else if (result.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
        }
      });
     }


      // Function to disable the user account
      const handleDisable  = async () => {
        const result = await Swal.fire({
          title: "Do you want to disable the user account?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Disable",
          denyButtonText: `Don't Disable`,
        });
      
        if (result.isConfirmed) {
          try {
            const response = await axios.post(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/disableUser/${userUID}`);
            setStatusMessage(response.data.message); // Show success message
            fetchAccountStatus(); // Update status after disabling
      
            // Display success message using Swal
            Swal.fire({
              title: 'User Disabled!',
              text: response.data.message,
              icon: 'success',
              confirmButtonText: 'Ok',
            }).then(()=>{
              fetchAccountStatus(); // Update status after enabling
            });
          } catch (error) {
            setStatusMessage('Error disabling user account');
            console.error('Error disabling user:', error);
      
            // Display error message using Swal
            Swal.fire({
              title: 'Error!',
              text: 'Error disabling user account.',
              icon: 'error',
              confirmButtonText: 'Ok',
            });
          }
        } else if (result.isDenied) {
          Swal.fire({
            title: 'Action Canceled',
            text: "The user account has not been disabled.",
            icon: 'info',
            confirmButtonText: 'Ok',
          });
        }
      };
      

  // Function to enable the user account
  const handleEnable  = async () => {
    const result = await Swal.fire({
      title: "Do you want to enable the user account?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Enable",
      denyButtonText: `Don't Enable`,
    });
  
    if (result.isConfirmed) {
      try {
        const response = await axios.post(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/enableUser/${userUID}`);
        setStatusMessage(response.data.message); // Show success message
        fetchAccountStatus(); // Update status after enabling
  
        // Display success message using Swal
        Swal.fire({
          title: 'User Enabled!',
          text: response.data.message,
          icon: 'success',
          confirmButtonText: 'Ok',
        }).then(()=>{
          fetchAccountStatus(); // Update status after enabling
        });
      } catch (error) {
        setStatusMessage('Error enabling user account');
        console.error('Error enabling user:', error);
  
        // Display error message using Swal
        Swal.fire({
          title: 'Error!',
          text: 'Error enabling user account.',
          icon: 'error',
          confirmButtonText: 'Ok',
        });
      }
    } else if (result.isDenied) {
      Swal.fire({
        title: 'Action Canceled',
        text: "The user account has not been enabled.",
        icon: 'info',
        confirmButtonText: 'Ok',
      });
    }
  };

  // Fetch the current status of the user account
  const fetchAccountStatus = async () => {
    try {
      const response = await axios.get(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/getUserStatus/${userUID}`);
      setAccountStatus(response.data.status); // 'enabled' or 'disabled'
      // Display the current status using Swal
      
    } catch (error) {
      setStatusMessage('Error fetching account status');
      console.error('Error fetching user status:', error);

      // Display error message using Swal
      Swal.fire({
        title: 'Error!',
        text: 'Error fetching account status.',
        icon: 'error',
        confirmButtonText: 'Ok'
      });
    }
  };
  

  return (
    <div>
      <div className='adminHeader'>
        <h5>User name : {data.clients[0].createdBy}</h5>
      </div>
      <div className='adminHeader1' >
        <div>
          <h2>{data.clients[0].createdBy}</h2>
        </div>
        <div>Account States : <h4>{accountStatus}</h4></div>
        <div>
      <h2>User Management</h2>
      {accountStatus === 'enabled' ?<button onClick={handleDisable} className="buttonDesign">
        Disable User 
      </button>:
      <button onClick={handleEnable} className="buttonDesign">
        Enable User Account
      </button>}
    </div>
      </div>
      <hr />
      <div className="optionBox">
        <div
          onClick={() => setSelectedState("Ongoing")}
          className={`Ongoingbox ${selectedState === "Ongoing" ? "selected" : ""}`}
        >
          <div className='paragraph' >
            <div>
              <p>Ongoing project - </p>

            </div>
            <div className='paragraph1'>
              <p> {OngoingLength} </p>
            </div>

          </div>
        </div>
        <div
          onClick={() => setSelectedState("completed")}
          className={`Ongoingbox ${selectedState === "completed" ? "selected" : ""}`}
        >
          <div className='paragraph' >
            <div>
              <p>Completed project - </p>

            </div>
            <div className='paragraph1'>
              <p> {CompletedLength} </p>
            </div>

          </div>
        </div>
        <div
          onClick={() => setSelectedState("UserDetails")}
          className={`Ongoingbox ${selectedState === "UserDetails" ? "selected" : ""}`}
        >
          <p>User Details</p>
        </div>
        <div>
          <Form>
            <InputGroup>
              <Form.Control onChange={(e) => setSearch(e.target.value)} placeholder="Search Projects" />
            </InputGroup>
          </Form>
        </div>
      </div>
      <hr />


      <div>
        <div>
          <div className="table-container">
            {loading ? (
              <div className="loader">Loading...</div>
            ) : filteredResults && filteredResults.length > 0 ? (
              <div className="tableScroll">
                <table>
                  <thead>
                    <tr>
                      <th>Project</th>
                      <th>Date</th>
                      <th>Name</th>
                      <th>Number</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredResults.length > 0 ? (
                      filteredResults?.map((e) => (
                        <tr key={e.ID}>
                          <td>{e.pname}</td>
                          <td>{e.date}</td>
                          <td>{e.cname}</td>
                          <td>{e.cphone}</td>
                          <td>{e.status}</td>
                          <td>
                            { selectedState === 'Ongoing' ? (<button onClick={()=> statesMode(e.id)} className='buttonDesign' >Mark as complete</button>):(<button onClick={()=> ongoingStatesMode(e.id)}  className='buttonDesign' >Mark as Ongoing</button>)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="noDataFound">No data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="noDataFound">No data available</div>
            )}
          </div>
          <hr />


        </div>
      </div>
    </div>
  )
}

export default ViewUserDetail